import React from "react"

const NavBars = (props) => {
    return (
        <div className="bm-burger-button custom-bm-burger-button" style={{ display:"block" }}>
            <span>
                <span className="bm-burger-bars" style={{ "position": "absolute", "height": "20%", "left": "0px", "right": "0px", "top": "0%", "opacity": "1" }}></span>
                <span className="bm-burger-bars" style={{ "position": "absolute", "height": "20%", "left": "0px", "right": "0px", "top": "40%", "opacity": "1" }}></span>
                <span className="bm-burger-bars" style={{ "position": "absolute", "height": "20%", "left": "0px", "right": "0px", "top": "80%", "opacity": "1" }}></span>
            </span>
        </div>
    )
}

export default NavBars;